

import $ from 'jquery';
import imagesLoaded from 'imagesloaded';
import 'fullpage.js';

const slidesLength = $('.slides__item').length;
const $currentWrapper = $('.slides__current');
const $body = $('body');
const $logo = $('.header__logo');

const renderCurrent = (currentIndex) => {
    $currentWrapper.html(`<span>${currentIndex}</span>/${slidesLength}`);
};

const toggleLogo = (currentIndex) => {
    if (currentIndex === 1 || currentIndex === slidesLength) {
        $logo.fadeIn();
    } else {
        $logo.fadeOut();
    }
};

const navColour = (currentIndex) => {
    if (currentIndex === slidesLength) {
        $body.removeClass('theme--light');
    } else {
        $body.addClass('theme--light');
    }
};

$('#fullpage').fullpage({
    sectionSelector: '.slides__item',
    anchors: ['slide1', 'slide2', 'slide3', 'slide4'],
    menu: '#menu',
    css3: true,
    scrollingSpeed: 1000,

    afterLoad(anchorLink, index) {
        renderCurrent(index);
        toggleLogo(index);
        navColour(index);
    },

    onLeave(index, nextIndex) {
        renderCurrent(nextIndex);
        toggleLogo(nextIndex);
        navColour(nextIndex);
    },
});

// Fade In images
const imgLoad = imagesLoaded('#fullpage', { background: '.slides__item' });
imgLoad.on('progress', (instance, image) => {
    image.element.classList.add('slides__item--loaded');
});



// WEBPACK FOOTER //
// ./source/scripts/components/slides.js